import {
  Bell,
  BookOpen,
  //Calendar,
  //CheckSquare,
  //Grid,
  //Heart,
  //Layout,
  //List,
  //PieChart,
  //Sliders,
  //MapPin,
  //Users,
  //Share,
  HelpCircle,
} from "react-feather";
import { CardSim } from "lucide-react";
import {
  FaSimCard,
  FaUsers,
  FaUser,
  FaHome,
  FaFile,
  FaExclamationTriangle,
  FaCog,
  FaLockOpen,
  FaRecycle,
  FaTimesCircle,
  FaHistory,
  FaCube,
} from "react-icons/fa";
import { FiBox } from "react-icons/fi";
import { MdHealthAndSafety } from "react-icons/md";

const pagesSection = [
  {
    href: "/",
    icon: FaHome,
    title: "sidebar.dashboard",
  },
  {
    href: "/crm",
    icon: FaUsers,
    title: "sidebar.crm",
    children: [
      {
        href: "/crm/admins",
        title: "sidebar.admins",
      },
      {
        href: "/crm/tenants",
        title: "sidebar.tenants",
      },
      {
        href: "/crm/managers",
        title: "sidebar.managers",
      },
      {
        href: "/crm/customers",
        title: "sidebar.customers",
      },
      {
        href: "/crm/users",
        title: "sidebar.subaccounts",
      },
    ],
  },
  {
    href: "/sims",
    icon: FaSimCard,
    title: "sidebar.sims",
    children: [
      {
        href: "/sims",
        title: "sidebar.sims",
      },
      {
        href: "/sims/purchase",
        title: "sidebar.purchaseSims",
      },
    ],
  },
  {
    href: "/account",
    icon: FaUser,
    title: "sidebar.account",
    children: [
      {
        href: "/profile",
        title: "sidebar.profile",
      },
      {
        href: "/account/billingproducts",
        title: "sidebar.billingProducts",
      },
      {
        href: "/account/invoices",
        title: "sidebar.invoices",
      },
      {
        href: "/account/statements",
        title: "sidebar.statements",
      },
      {
        href: "/account/orders",
        title: "sidebar.orders",
      },
      {
        href: "/account/purchase-orders",
        title: "sidebar.purchaseOrders",
      },
      {
        href: "/account/emails",
        title: "sidebar.emails",
      },
      {
        href: "/account/whitelist",
        title: "sidebar.whitelist",
      },
      {
        href: "/account/customFields",
        title: "sidebar.customFields",
      },
      // {
      //   href: "/account/webhooks",
      //   title: "Webhooks",
      // },
    ],
  },
  {
    href: "/catalogue",
    icon: FiBox,
    title: "Catalog",
    children: [
      {
        href: "/catalogue/offers",
        title: "View Offers",
      },
      {
        href: "/catalogue/sim-products",
        title: "Sim Products",
      },
    ],
  },
  {
    href: "/reports",
    icon: FaFile,
    title: "sidebar.reports",
    children: [
      {
        href: "/reports/single",
        title: "sidebar.generateReport",
        icon: FaFile,
      },
      {
        href: "/reports/automated",
        title: "sidebar.automatedReports",
        icon: FaTimesCircle,
      },
      {
        href: "/reports/history",
        title: "sidebar.reportHistory",
        icon: FaHistory,
      },
    ],
  },
  {
    href: "/alerts",
    icon: FaExclamationTriangle,
    title: "sidebar.alerts",
  },
  // {
  //   href: "/support",
  //   icon: HelpCircle,
  //   title: "Support",
  // },
  {
    href: "/notifications",
    icon: Bell,
    title: "sidebar.notifications",
  },
  {
    href: "/pages/settings",
    icon: FaCog,
    title: "sidebar.settings",
  },
  {
    href: "/pages/privileges",
    icon: FaLockOpen,
    title: "sidebar.privileges",
  },
  {
    href: "/pages/services",
    icon: FaCube,
    title: "sidebar.services",
  },
  {
    href: "/pages/sim-products",
    icon: CardSim,
    title: "sidebar.simProducts",
  },
  {
    href: "/pages/health",
    icon: MdHealthAndSafety,
    title: "sidebar.health",
  },
  {
    href: "/docs/introduction",
    icon: BookOpen,
    title: "sidebar.documentation",
  },
];

const navItems = [
  {
    pages: pagesSection,
  },
];

export default navItems;
